export default "__VITE_ASSET__HF6Z2kcK__"